import { getTokenValue } from '@atlaskit/tokens';

export const overrideMarks: string[] = ['backgroundColor'];

export const DEFAULT_COLOR = {
	color: getTokenValue('color.text'),
	label: 'Default',
};